export const selectEnableSelection = state => state.content.enable_selection;
